export const objectIsEmpty = object => {
  if (object) {
    return Object.entries(object).length === 0;
  }

  return true;
};
